/* ============================================================
   MP PRODUCT — Inietta riga "Ispirato Specialty di [Nome]"
   ORDINE: Titolo → Ispirato → Tag olfattivi → Prezzo
   Sorgente: window.MP_PRODUCT_INSPIRED (metafield custom.inspired_by).
   MutationObserver-based: sopravvive ai re-render di Broadcast.
   ============================================================ */
(function () {
  'use strict';

  var building = false;
  var pendingRebuild = false;

  /* Trova il blocco prezzo Broadcast (non il container interno) */
  function getPriceBlock() {
    return document.querySelector('.product__price') ||
           document.querySelector('.price--large') ||
           document.querySelector('.price__container');
  }

  function needsBuild() {
    var raw = (window.MP_PRODUCT_INSPIRED || '').toString().trim();
    if (!raw) return false;
    if (document.querySelector('.mp-inspired-line')) return false;
    return !!getPriceBlock();
  }

  function buildLine() {
    var raw = (window.MP_PRODUCT_INSPIRED || '').toString().trim();
    if (!raw) return;
    if (document.querySelector('.mp-inspired-line')) return;

    var priceBlock = getPriceBlock();
    if (!priceBlock) return;

    building = true;

    /* Crea la riga "Ispirato Specialty di [Nome]" */
    var line = document.createElement('div');
    line.className = 'mp-inspired-line';
    line.setAttribute('role', 'note');

    var label = document.createElement('span');
    label.className = 'mp-inspired-line__label';
    // 21-10-2026: un modello può cambiare l'etichetta e chiedere la (i) (snippets/mp-reinterpretazione, prova note-reali-36j)
    label.textContent = window.MP_PRODUCT_INSPIRED_LABEL || 'Ispirato Specialty di';

    var val = document.createElement('span');
    val.className = 'mp-inspired-line__value';
    val.textContent = raw;

    line.appendChild(label);
    line.appendChild(val);
    if (window.MP_PRODUCT_INSPIRED_INFO) {
      var info = document.createElement('button');
      info.type = 'button';
      info.className = 'mp-inspired-line__i';
      info.setAttribute('data-mp-reint-open', '');
      info.setAttribute('aria-haspopup', 'dialog');
      info.setAttribute('aria-label', 'Che cos’è una reinterpretazione Specialty');
      info.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.6v.2"/></svg>';
      val.appendChild(info); // dentro il nome: se va a capo, va a capo insieme al nome
    }

    /* Inserisci PRIMA del blocco prezzo (non dentro) */
    priceBlock.parentNode.insertBefore(line, priceBlock);

    /* Sposta i tag olfattivi (.mp-otags) DOPO la riga ispirato e PRIMA del prezzo.
       Erano dentro il blocco titolo — li riposizioniamo nel corretto ordine visivo. */
    var tagsWrap = document.querySelector('.mp-otags');
    if (tagsWrap) {
      priceBlock.parentNode.insertBefore(tagsWrap, priceBlock);
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { building = false; });
    });
  }

  function maybeRebuild() {
    if (building || pendingRebuild) return;
    if (!needsBuild()) return;
    pendingRebuild = true;
    requestAnimationFrame(function () {
      pendingRebuild = false;
      if (needsBuild()) buildLine();
    });
  }

  function attachObserver() {
    if (document.body.getAttribute('data-mp-inspired-observed')) return;
    document.body.setAttribute('data-mp-inspired-observed', '1');
    var observer = new MutationObserver(maybeRebuild);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    buildLine();
    attachObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', maybeRebuild);
  document.addEventListener('variant:change', maybeRebuild);

  // ====== MP SOLD-OUT BODY FLAG ======
  function syncSoldoutFlag() {
    var btn = document.querySelector('button[name="add"]');
    if (!btn) return;
    var soldout = btn.disabled || btn.hasAttribute('disabled');
    document.body.classList.toggle('mp-soldout', !!soldout);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncSoldoutFlag, { once: true });
  } else {
    syncSoldoutFlag();
  }
  document.addEventListener('shopify:section:load', syncSoldoutFlag);
  document.addEventListener('variant:change', syncSoldoutFlag);

  var btnObserver;
  function attachBtnObserver() {
    var btn = document.querySelector('button[name="add"]');
    if (!btn || btnObserver) return;
    btnObserver = new MutationObserver(syncSoldoutFlag);
    btnObserver.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachBtnObserver, { once: true });
  } else {
    attachBtnObserver();
  }
})();
